import { render, staticRenderFns } from "./UserActionLogList.vue?vue&type=template&id=0ca2fe9a&scoped=true&"
import script from "./UserActionLogList.vue?vue&type=script&lang=js&"
export * from "./UserActionLogList.vue?vue&type=script&lang=js&"
import style0 from "./UserActionLogList.vue?vue&type=style&index=0&id=0ca2fe9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2fe9a",
  null
  
)

export default component.exports